import styled from 'styled-components';
import Button from 'components/button/Button';
import theme from 'styles/theme';

export const StyledButton = styled(Button)`
  font-weight: 800;
  padding: 0;
  line-height: 1;
  color: ${theme.colors.danger};

  &:hover {
    color: ${theme.colors.danger};
  }
`;
